import React from 'react';
import {
  Action,
  withInject,
} from '@piwikpro/platform';
import { withTranslation } from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings } from '../../../TrackerSettings';

export interface ExcludedUserAgentsProps {
  appId: string
  trackerSettings: TrackerSettings
  globalAndAppTrackerSettings: Array<string | object>
  validation: FormValidator
  t: (key: string) => string
}

class ExcludedUserAgents extends React.Component<ExcludedUserAgentsProps> {
  constructor(props: ExcludedUserAgentsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: {
    setErrors: Function
    setSubmitting: Function
    setFieldValue: Function
  }) {
    const {
      trackerSettings,
      appId,
      globalAndAppTrackerSettings,
    } = this.props;
    const field = Object.keys(values)[0];
    const valuesWithoutGlobals = {
      [field]: values[field].filter((element: any) => !element.disabled),
    };

    try {
      await trackerSettings.updateSettingsForApp(appId, valuesWithoutGlobals);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        field,
        globalAndAppTrackerSettings,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const {
      globalAndAppTrackerSettings,
      validation,
      t,
    } = this.props;

    return (
      <Action.AutoSavedTagsInputControl
        id="app-settings-blacklisting-user-agents"
        label="&nbsp;"
        info={`${t('apps.details.settings.blacklisting.exclude-ua.help')} ${t('components:tagsInput.placeholder.default')}`}
        name="excluded_user_agents"
        initialValue={globalAndAppTrackerSettings}
        validationSchema={validation.createValidationSchema(validators => ({
          excluded_user_agents: validators.trackerSettings.excludedUserAgents,
        }))}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(
  withTranslation(['administration'])(ExcludedUserAgents as any),
);
